import { TextArea as BPTextArea } from '@blueprintjs/core';
import * as React from 'react';

import './TextArea.scss';

export interface ITextAreaProps {
  id?: string;
  className?: string;
  label?: React.ReactNode;
  value?: string | ReadonlyArray<string> | number;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
}

const TextArea: React.FC<ITextAreaProps> = ({ id, className = '', label, value, onChange }) => {
  const fullClassName = `nn-textarea ${className}`;
  return (
    <div className={fullClassName} id={id}>
      {label ? <p>{label}</p> : null}
      <BPTextArea className="nn-body-text" fill={true} autoResize={true} value={value} onChange={onChange} />
    </div>
  );
};

export default TextArea;
